import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { map } from "rxjs/operators";
import { Booking } from "../../../Modals/booking.model";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class ApiService {
    constructor(private httpClient: HttpClient) {}

    getHomeSlider() {
        return this.httpClient.get(`${environment.apiUrl}` + "/user/sliders");
    }

    getHospitals() {
        return this.httpClient.get(
            `${environment.apiUrl}` +
                "/user/hospitals?" +
                `lang=${
                    localStorage.getItem("lang")
                        ? localStorage.getItem("lang")
                        : "ar"
                }`
        );
    }

    getDiseases() {
        return this.httpClient.get(
            `${environment.apiUrl}` +
                "/user/diseases?" +
                `lang=${
                    localStorage.getItem("lang")
                        ? localStorage.getItem("lang")
                        : "ar"
                }`
        );
    }

    getPatientBookings() {
        let header = new HttpHeaders().set(
            "Authorization",
            "Bearer" + " " + localStorage.getItem("token")
        );
        return this.httpClient.get(
            `${environment.apiUrl}` +
                "/user/booking/" +
                localStorage.getItem("userID"),
            { headers: header }
        );
    }

    requestBooking(booking: Booking) {
        console.log(booking);
        const formData: FormData = new FormData();
        if (booking.main_patient == "0") {
            formData.append("name", booking.name);
            formData.append("mobile", booking.mobile);
            formData.append("nation", booking.nation);
            formData.append("gender", booking.gender);
            formData.append("dateofbirth", booking.dateofbirth);
            formData.append("email", booking.email);
        }

        formData.append("user_id", localStorage.getItem("userID"));

        formData.append("main_patient", booking.main_patient);
        formData.append("description", booking.description);

        if (
            booking.idPhoto !== undefined &&
            booking.idPhoto.name
        ) {
            formData.append(
                "id_photo",
                booking.idPhoto,
                booking.idPhoto.name
            );
        }

        if (
            booking.medical_report !== undefined &&
            booking.medical_report.name
        ) {
            formData.append(
                "medical_report",
                booking.medical_report,
                booking.medical_report.name
            );
        }
        if (booking.radiology !== undefined && booking.radiology.name) {
            formData.append(
                "radiology",
                booking.radiology,
                booking.radiology.name
            );
        }
        if (booking.retina !== undefined && booking.retina.name) {
            formData.append("retina", booking.retina, booking.retina.name);
        }

        formData.forEach((e, i) => {
            console.log(e);
        });
        let header = new HttpHeaders().set(
            "Authorization",
            "Bearer" + " " + localStorage.getItem("token")
        );
        return this.httpClient
            .post(`${environment.apiUrl}` + "/user/booking", formData, {
                headers: header,
            })
            .pipe(
                map((response: any) => {
                    console.log(response);
                })
            );
    }

    userReply(file: File, message: string, messageID) {
        const formData: FormData = new FormData();

        formData.append("rmessage", message);

        if (file !== undefined && file.name) {
            formData.append("rfile", file, file.name);
        }

        let header = new HttpHeaders().set(
            "Authorization",
            "Bearer" + " " + localStorage.getItem("token")
        );
        return this.httpClient
            .post(
                `${environment.apiUrl}` +
                    "/user/booking_user_replay/" +
                    messageID,
                formData,
                {
                    headers: header,
                }
            )
            .pipe(
                map((response: any) => {
                    console.log(response);
                })
            );
    }
}
